<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_8"></a>Copyright © 2002 and 2016 by Robb Walsh.<br/>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher. <span href="#/xhtml/122chapter113#page_292" title="Link target outside of Sample">Page 292</span> constitutes a continuation of the copyright page.</p>
<p>ISBN 978-1-4521-4625-6 (epub, mobi)</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN 978-1-4521-3998-2 (pb)</p>
<p>Designed by Erin Mayes and DJ Stout, Pentagram, Austin<br/>Typesetting by River Jukes-Hudson<br/>Diagrams by A.J. Garces, with revisions on <span href="#/xhtml/103chapter94a#page_241" title="Link target outside of Sample">page 241</span> by Amanda Fung</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05copyright.vue?dd87be6c